import { Todo } from '@deliveries-app/models';
import { RootReducerState } from '../../store/reducer';
import { darkenColor } from '../../utils/helpers';
import { useSelector } from 'react-redux';

interface TodoItem {
  item: Todo;
  onChecked: () => void;
  onDelete: () => void;
}

export default function Todoitem({ item, onChecked, onDelete }: TodoItem) {
  const branchColour = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch?.branch_colour
  );
  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-row items-center">
        <input
          id={`todo-${item.id}`}
          name={`todo-${item.id}`}
          type={'checkbox'}
          checked={item.completed_at ? true : false}
          onChange={onChecked}
          className={`h-4 w-4 rounded border-gray-300`}
          style={{
            color: branchColour,
            transition: 'background-color 0.3s, box-shadow 0.3s',
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              darkenColor(branchColour, 20);
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              'white';
          }}
          onFocus={(e) => {
            (
              e.currentTarget as HTMLButtonElement
            ).style.boxShadow = `0 0 0 3px ${branchColour}`;
          }}
          onBlur={(e) => {
            (e.currentTarget as HTMLButtonElement).style.boxShadow = 'none';
          }}
        />
        <p
          className={`ml-2 text-sm`}
          style={{
            textDecoration: item.completed_at ? 'line-through' : 'none',
          }}
        >
          {item.content}
        </p>
      </div>

      <div className="group relative cursor-pointer" onClick={onDelete}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="h-4 w-4 transition duration-300 group-hover:-translate-x-8 group-hover:text-red-500 group-hover:opacity-0"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <span className="absolute right-0 top-0 text-xs opacity-0 transition duration-300 group-hover:text-red-500 group-hover:opacity-100">
          Delete?
        </span>
      </div>
    </div>
  );
}
